import SelectedStoreBase from "../../../../common/state/modules/globallySelected";
import SingleSelectedProperty from "../../../../common/state/modules/singleSelectedProperty";
import FormElement from "../../models/formElements/formElement";
import WorkflowStep from "../../models/workflow/workflowStep";
import FormSection from "../../models/formSections/formSection";
import Organization from "../../../../common/models/organization";
import Group from "../../../organization_management/models/group";
import User from "../../../../common/models/user";
import Form from "../../models/form";

export default class GloballySelected extends SelectedStoreBase {
  static currentUser = new SingleSelectedProperty('currentUser', () => User);
  static formElement = new SingleSelectedProperty('formElement', () => FormElement);
  static workflowStep = new SingleSelectedProperty('workflowStep', () => WorkflowStep);
  static formSection = new SingleSelectedProperty('formSection', () => FormSection);
  static organization = new SingleSelectedProperty('organization', () => Organization);
  static form = new SingleSelectedProperty('form', () => Form);
  static workflowStepToDelete = new SingleSelectedProperty('workflowStepToDelete', () => WorkflowStep);
  static jumpToFormSection = new SingleSelectedProperty('jumpToFormSection', () => FormSection);
  static jumpToWorkflowStep = new SingleSelectedProperty('jumpToWorkflowStep', () => WorkflowStep);

  static group = new SingleSelectedProperty('group', () => Group);
}